import { useState } from "react";
import { Button, TextField, Typography } from "@repo/design-system";

interface ISourceIdsFieldProps {
  sourceIds: string[];
  onChange: (next: string[]) => void;
}

export function SourceIdsField({ sourceIds, onChange }: ISourceIdsFieldProps) {
  const [draft, setDraft] = useState("");

  const addChip = (raw: string) => {
    const trimmed = raw.trim();
    if (!trimmed) return;
    if (sourceIds.some((id) => id.toLowerCase() === trimmed.toLowerCase())) {
      setDraft("");
      return;
    }
    onChange([...sourceIds, trimmed]);
    setDraft("");
  };

  const removeChip = (id: string) =>
    onChange(sourceIds.filter((existing) => existing !== id));

  return (
    <div className="flex flex-col gap-2">
      <TextField
        label="Source IDs"
        description="A compound must match every ID entered — bare (2326) and prefixed (AID2326) forms are treated the same."
        placeholder="Type an ID and press Enter"
        value={draft}
        onChange={setDraft}
        onSubmit={addChip}
        clearable
        onClear={() => setDraft("")}
      />
      {sourceIds.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {sourceIds.map((id) => (
            <div
              key={id}
              className="flex items-center gap-1 rounded-pill bg-backgroundBrand px-2.5 py-1">
              <Typography
                variant="paragraph-m-medium"
                className="text-contentOnBrand">
                {id}
              </Typography>
              <Button
                variant="transparent"
                size="small"
                leftIcon="close"
                className="p-0.5 text-contentOnBrand"
                onPress={() => removeChip(id)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
